// extracted by mini-css-extract-plugin
export default {"wrapper":"fii7pTA","tabItem":"H3a_Fhh","active":"mU5SLoN"};